import { Button, styled } from '@mui/material'

export const StyledButton = styled(Button)({
  background: 'linear-gradient(158.55deg, #202CD3 5.3%, #02E39F 102.34%)',
  borderRadius: '75px',
  border: 'none',
  color: '#fff',
  textTransform: 'none',
  fontSize: '16px',
  fontWeight: 600,
  '&:hover': {
    background: 'linear-gradient(158.55deg, #02E39F 5.3%, #202CD3 102.34%)',
    border: 'none'
  }
}) as typeof Button

export const ApplePayButton = styled(Button)(() => ({
  fontWeight: 600,
  fontSize: '20px',
  flex: 1,
  height: '48px',
  backgroundColor: '#000000',
  color: '#ffffff',
  borderRadius: '8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#333333',
    boxShadow: 'none'
  }
})) as typeof Button

export const PayPalPayButton = styled(Button)(({ theme }) => ({
  fontWeight: '600',
  fontSize: '16px',
  minHeight: '48px',
  flex: 1,
  backgroundColor: '#1C47CB',
  boxShadow: 'none',
  color: '#ffffff',
  '&:hover': {
    backgroundColor: '#1d4ee0',
    boxShadow: 'none'
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '12px'
  }
})) as typeof Button
